import Blue from "../core";

new Blue({
	name: 'Accordion',
	selector: ".accordion",
	setup(accordion) {
    const items = [...accordion.querySelectorAll('.accordion__item')];
    const relations = [];
		const expandCollapseSwitch = accordion.querySelector(".accordion__toggle");
		let toggles = [];
		let allExpanded = false;
		let noneExpanded =false;
		let toggleActive = false;
		
		// Can be used if we want to do separate expand/collapse labels that show/hide based on allExpanded vs noneExpanded
		// const toggleLabel = expandCollapseSwitch.querySelector(".accordion__toggle-label");
		// const expandText = accordion.getAttribute("data-expand-text") || "Expand All";
		// const collapseText = accordion.getAttribute("data-collapse-text") || "Collapse All";
		// toggleLabel.textContent = expandText;

		const expandAll = () => {
			toggles.forEach(togglet => togglet.open());
		} 

		const collapseAll = () => {
			toggles.forEach(togglet => togglet.close());
		}

		const setExpandedDomSettings = (opening) => {
			expandCollapseSwitch.setAttribute("aria-expanded", opening);
			if (opening) expandCollapseSwitch.classList.add("all-expanded");
			else expandCollapseSwitch.classList.remove("all-expanded");
			toggleActive = opening;

			// Can be used if we want to do separate expand/collapse labels that show/hide based on allExpanded vs noneExpanded
			// toggleLabel.textContent = opening ? collapseText : expandText;
		}

		const setExpandedVarValues = () => {
			allExpanded = items.every(item => item.matches('[data-active]'));
			noneExpanded = items.every(item => !item.matches('[data-active]'));
		}

    items.forEach(container => {
      let trigger = container.querySelector('.accordion__trigger')
      let content = container.querySelector('.accordion__content')
      let config = {
        container,
        trigger,
        content,
        relations
      }
			let togglet = new this.$toggle(config);

			toggles.push(togglet);

			// If user opens/closes all items manually, update expandCollapseSwitch accordingly
			togglet.onToggle(() => {
				setExpandedVarValues();
				if (allExpanded) {
					setExpandedDomSettings(true);
				} else if (noneExpanded) {
					setExpandedDomSettings(false);
				}
			})
    });

		setExpandedDomSettings(false);

		this.$addEvents(expandCollapseSwitch, "click.prevent", () => {
			if (toggleActive) {
				collapseAll();
				setExpandedDomSettings(false);
			}
			else {
				expandAll();
				setExpandedDomSettings(true);
			}
		});
	}
});